module.exports = __webpack_public_path__ + "static/img/lunbo.ec9227e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_10/lunbo.jpg
// module id = XBuz
// module chunks = 0